/**
 * Media URL Utility
 * Converts relative media paths to full URLs for React dev server
 */

/**
 * Convert relative media path to full URL
 * @param {string} path - Media path (relative or absolute)
 * @returns {string|null} Full URL or null if path is invalid
 */
export const getMediaUrl = (path) => {
  if (!path) return null;
  
  // Already a full URL - return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Relative upload path - prepend base URL
  if (path.startsWith('/uploads/')) {
    const API_BASE = process.env.REACT_APP_API_URL || 'https://supernovalab.ai/api';
    const baseUrl = API_BASE.replace('/api', '');
    return `${baseUrl}${path}`;
  }
  
  // Other relative paths
  return path;
};

/**
 * Convert multiple media paths at once
 * @param {Object} obj - Object containing media paths
 * @param {Array} keys - Keys to convert
 * @returns {Object} Object with converted paths
 */
export const convertMediaUrls = (obj, keys = ['image', 'video', 'avatar']) => {
  const converted = { ...obj };
  
  keys.forEach(key => {
    if (converted[key]) {
      converted[key] = getMediaUrl(converted[key]);
    }
  });
  
  return converted;
};